export default "__VITE_ASSET__BkoRNcLP__"